import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage'
import authReducer from '../reducers/authReducer'
import snackReducer from '../reducers/snackReducer'
import loaderReducer from '../reducers/loaderReducer';

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    Auth: authReducer,
    Snack: snackReducer,
    Loader: loaderReducer
})
const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk]
})

export const persistor = persistStore(store)